export default [
    {
        type: 1,
        name: 'KEY',
        devices_type: [1, 2, 7, 8, 10, 11, 12, 13, 14, 15],
    },
    {
        type: 3,
        name: 'REMOTE',
        devices_type: [3],
    },
    {
        type: 4,
        name: 'DIMMER',
        devices_type: [4, 9],
    },
    {
        type: 5,
        name: 'THERMOSTAT',
        devices_type: [5],
    },
    {
        type: 9,
        name: 'RGB',
        devices_type: [9],
        channel_number: 2
    },
    {
        type: 99,
        name: 'WIRELESS-KEY',
        devices_type: [3],
        channel_number: 1
    },
    {
        type: 100,
        name: 'TELEVESION',
        devices_type: [3],
    },
    {
        type: 501,
        name: 'FAN-COIL',
        devices_type: [5],
        channel_number: 2
    },
    {
        type: 401,
        name: 'SCENARIO-KEY',
        devices_type: [1, 2, 7, 8, 10, 11, 12, 13, 14, 15],
    },
    {
        type: 503,
        name: 'HUMIDITY',
        devices_type: [5],
        channel_number: 1
    },
    {
        type: 502,
        name: 'MOTOR',
        devices_type: [5],
        channel_number: 1
    },
    {
        type: 9997,
        name: 'CAMERA',
        devices_type: [],
    },
    {
        type: 9998,
        name: 'INPUT',
        devices_type: [10, 12, 4, 9, 5],
    },
    {
        type: 9999,
        name: 'INPUT-STATUS',
        devices_type: [10, 12, 4, 9, 5, 3],
    },
    {
        type: 600,
        name: 'DATA-LOGGER',
        devices_type: [16],
    },
]